(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }
  document.querySelectorAll('.quick-add').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const old = button.textContent;
      button.disabled = true;
      button.textContent = 'Ajout…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
        if (!response.ok) throw new Error('cart');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => el.textContent = cart.item_count);
        button.textContent = 'Ajouté ✓';
      } catch (_) { button.textContent = 'Réessayer'; }
      setTimeout(() => { button.disabled = false; button.textContent = old; }, 1400);
    });
  });
})();
